import classNames from 'classnames';
import classes from '../LeaderBoard.module.scss';

export const renderPositionDiffCell = (position: number) => {
  return (
    <span
      className={classNames(classes['leader-board__table-position-diff'], {
        [classes['leader-board__table-position-diff--up']]: position > 0,
        [classes['leader-board__table-position-diff--down']]: position < 0,
        [classes['leader-board__table-position-diff--same']]: position === 0,
      })}
    >
      {Math.abs(position)}
    </span>
  );
};
